import atlasApi from '..'

const notifyMessage = async (payload) => {
  return atlasApi.post('v2/webhooks/slack', payload)
}

export { notifyMessage }
